import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@uikit/Form/Button/Button';
import urls from '@constants/urls';
import { redirectUserTo } from '@utils/historyHandler';

export default function (): JSX.Element {
  const history = useHistory();
  const onButtonClick = () => {
    redirectUserTo(history, urls.SETTINGS_WORKSPACE);
  };

  return (
    <Button size="m" className="button--additional" onClick={onButtonClick}>
      Cancel
    </Button>
  );
}
